import React from "react";
import styles from "./SHProducts.module.scss";
import { ImageCarousel } from "./ImageCarousel";
import { VideoCard } from "./VideoCard";
import { parseLines } from "../../../../utils";
import PlaceHolder from "../../../../static/images/imagePlaceholder.svg";

export const MaterialDetailView = ({ material, onBack, onRequestMoreInfo, successMessage, loading }) => {
  const {
    materialImages,
    materialNumber,
    materialDesc,
    isFormularyProduct,
    manufacturer,
    packaging,
    productFamilyCoreDesc,
    keyBenefits,
    videos = [],
    specification = [],
    competitors = [],
  } = material;

  const images = (materialImages || []).map((img) => img.image).filter(Boolean);
  const descriptionLines = parseLines(productFamilyCoreDesc);
  const benefitLines = parseLines(keyBenefits);
  const isFormulary = isFormularyProduct === 1;

  return (
    <div className={styles.detail_view}>
      <button type="button" className={styles.back_link} onClick={onBack}>
        ‹ Back
      </button>

      <ImageCarousel images={images} altText={materialDesc} />

      <div className={styles.detail_header}>
        <h3 className={styles.detail_title}>SKU: {materialNumber || "—"}</h3>
        <p className={styles.detail_category}>{materialDesc || "—"}</p>
        <p className={styles.formulary_row}>
          Formulary Item: <span className={styles.formulary_yes_no}>{isFormulary ? "Yes" : "No"}</span>
        </p>
      </div>

      <div className={styles.divider} />

      <div className={styles.manufacturer_row}>
        <span>
          Manufacturer: <span className={styles.manufacturer_text}>{manufacturer}</span>
        </span>
      </div>

      <div className={styles.divider} />

      <p className={styles.packaging_text}>
        Packaging: <span className={styles.formulary_yes_no}>{packaging || "—"}</span>
      </p>

      {descriptionLines.length > 0 && (
        <div className={styles.section}>
          <h4 className={styles.section_title}>Description</h4>
          {descriptionLines.map((line, idx) => (
            <p key={idx} className={styles.section_text}>
              {line}
            </p>
          ))}
        </div>
      )}

      {benefitLines.length > 0 && (
        <div className={styles.section}>
          <h4 className={styles.section_title}>Key Benefits</h4>
          <ul className={styles.benefits_list}>
            {benefitLines.map((line, idx) => (
              <li key={idx}>{line}</li>
            ))}
          </ul>
        </div>
      )}

      {videos?.length > 0 && (
        <div className={styles.section}>
          <h4 className={styles.section_title}>Videos</h4>
          <div className={styles.videos_list}>
            {videos.map((video, idx) => (
              <VideoCard key={video.videoUrl || idx} video={video} />
            ))}
          </div>
        </div>
      )}

      {competitors?.length > 0 && (
        <div className={styles.section}>
          <h4 className={styles.section_title}>Compare to other brands</h4>
          <div className={styles.competitors_list}>
            {competitors.map((competitor) => (
              <div className={styles.competitor} key={competitor?.competitorName}>
                <img
                  src={competitor?.image}
                  alt={competitor?.competitorName}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = PlaceHolder;
                  }}
                />
                <span>{competitor?.competitorName}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {specification?.length > 0 && (
        <div className={styles.section}>
          <h4 className={styles.section_title}>Specification</h4>
          <div className={styles.spec_table}>
            {specification.map((spec, idx) => (
              <div key={idx} className={styles.spec_row}>
                <span className={styles.spec_attr}>{spec.skuSpecAttribute}</span>
                <span className={styles.spec_value}>{spec.skuSpecAttributeValue}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className={styles.divider} />

      {successMessage && (
        <div className={styles.successBanner}>
          <div>Thank you for reaching out to us!</div>
          <div>{successMessage}</div>
        </div>
      )}

      <div className={styles.footer}>
        <p>Have a question? We're here to help!</p>
        <button type="button" className={styles.request_info_btn} onClick={() => onRequestMoreInfo("material", isFormularyProduct)}>
          {loading && <span data-testid="loading-spinner" className={styles.custom_spinner}></span>}
          Request more info
        </button>
      </div>
    </div>
  );
};
